module.exports = __webpack_public_path__ + "img/letter-ninety.db0e7146.png";